import * as React from "react";
const ConstructionSVG = (props) => (
  <svg
    width={25}
    height={25}
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.4368 8.65852V5.47852"
      stroke="#757B8A"
      strokeWidth={1.27333}
      strokeMiterlimit={10}
    />
    <path
      d="M14.2493 8.65852V5.47852"
      stroke="#757B8A"
      strokeWidth={1.27333}
      strokeMiterlimit={10}
    />
    <path
      d="M9.79593 11.2051H7.24927"
      stroke="#757B8A"
      strokeWidth={1.27333}
      strokeMiterlimit={10}
    />
    <path
      d="M17.4366 11.2051H14.8899"
      stroke="#757B8A"
      strokeWidth={1.27333}
      strokeMiterlimit={10}
    />
    <path
      d="M18.0699 11.2052C18.0682 9.68692 17.4642 8.23134 16.3907 7.15777C15.3171 6.08419 13.8615 5.48028 12.3432 5.47852C10.825 5.48028 9.36941 6.08419 8.29583 7.15777C7.22226 8.23134 6.61835 9.68692 6.61658 11.2052C6.43112 11.2043 6.24772 11.2442 6.07936 11.322C5.91099 11.3998 5.76177 11.5136 5.64222 11.6554C5.52268 11.7972 5.43573 11.9635 5.38753 12.1426C5.33932 12.3217 5.33103 12.5092 5.36325 12.6918C5.42695 12.9963 5.59509 13.2689 5.83859 13.4625C6.08208 13.6561 6.38559 13.7584 6.69658 13.7518H18.0299C18.3409 13.7584 18.6444 13.6561 18.8879 13.4625C19.1314 13.2689 19.2996 12.9963 19.3632 12.6918C19.3962 12.5058 19.3871 12.3148 19.3366 12.1327C19.2862 11.9506 19.1956 11.7822 19.0716 11.6396C18.9476 11.4971 18.7933 11.3841 18.62 11.3089C18.4467 11.2338 18.2587 11.1983 18.0699 11.2052Z"
      stroke="#757B8A"
      strokeWidth={1.27333}
      strokeMiterlimit={10}
    />
    <path
      d="M7.24927 13.7521H17.4359V14.4188C17.4271 15.7638 16.8866 17.0508 15.9324 17.9988C14.9782 18.9467 13.6877 19.4788 12.3426 19.4787C10.9918 19.4787 9.69626 18.9421 8.74107 17.9869C7.78589 17.0318 7.24927 15.7363 7.24927 14.3854V13.7188V13.7521Z"
      stroke="#757B8A"
      strokeWidth={1.27333}
      strokeMiterlimit={10}
    />
  </svg>
);
export default ConstructionSVG;
